import React, { useEffect, useState } from 'react';
import { DocumentGrid } from './DocumentGrid';
import { DocumentFilters } from './DocumentFilters';
import { DocumentPreview } from './DocumentPreview';
import { DownloadIcon, BookmarkIcon, RefreshCwIcon, PlusIcon, FileTextIcon, ExternalLinkIcon, FilterIcon, ListFilterIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
// Sample document data
const sampleDocuments = [{
  id: 'INV-2023-001',
  type: 'Invoice',
  typeCode: 'INV',
  date: '2023-10-15',
  dueDate: '2023-11-15',
  amount: 1250.75,
  status: 'Approved',
  vendor: 'Office Depot',
  entity: 'Global Technologies Inc.',
  site: 'New York HQ',
  createdBy: 'John Smith',
  createdDate: '2023-10-10',
  lastModified: '2023-10-15',
  tags: ['IT Department', 'Q4'],
  hasAttachments: true,
  attachmentCount: 2,
  hasNotes: true,
  noteCount: 3,
  hasTags: true,
  hasWarnings: false,
  hasErrors: false,
  isImported: true,
  ocrConfidence: 0.92,
  linkedDocuments: ['PO-2023-001'],
  previewUrl: 'https://templates.invoicehome.com/invoice-template-us-neat-750px.png'
}, {
  id: 'PO-2023-001',
  type: 'Purchase Order',
  typeCode: 'PO',
  date: '2023-10-05',
  dueDate: null,
  amount: 1500.0,
  status: 'Sent to Vendor',
  vendor: 'Office Depot',
  entity: 'Global Technologies Inc.',
  site: 'New York HQ',
  createdBy: 'Sarah Williams',
  createdDate: '2023-10-03',
  lastModified: '2023-10-05',
  tags: ['IT Department', 'Q4'],
  hasAttachments: false,
  attachmentCount: 0,
  hasNotes: true,
  noteCount: 1,
  hasTags: true,
  hasWarnings: false,
  hasErrors: false,
  isImported: false,
  ocrConfidence: null,
  linkedDocuments: ['INV-2023-001', 'REQ-2023-002'],
  previewUrl: 'https://templates.invoicehome.com/purchase-order-template-us-classic-white-750px.png'
}, {
  id: 'REQ-2023-002',
  type: 'Requisition',
  typeCode: 'REQ',
  date: '2023-09-28',
  dueDate: null,
  amount: 1500.0,
  status: 'Approved',
  vendor: 'Office Depot',
  entity: 'Global Technologies Inc.',
  site: 'New York HQ',
  createdBy: 'Michael Johnson',
  createdDate: '2023-09-25',
  lastModified: '2023-09-28',
  tags: ['IT Department'],
  hasAttachments: false,
  attachmentCount: 0,
  hasNotes: false,
  noteCount: 0,
  hasTags: true,
  hasWarnings: false,
  hasErrors: false,
  isImported: false,
  ocrConfidence: null,
  linkedDocuments: ['PO-2023-001'],
  previewUrl: null
}, {
  id: 'CN-2023-001',
  type: 'Credit Note',
  typeCode: 'CN',
  date: '2023-10-20',
  dueDate: null,
  amount: 250.0,
  status: 'Processed',
  vendor: 'Dell Technologies',
  entity: 'Global Technologies Inc.',
  site: 'New York HQ',
  createdBy: 'John Smith',
  createdDate: '2023-10-18',
  lastModified: '2023-10-20',
  tags: ['Finance'],
  hasAttachments: true,
  attachmentCount: 1,
  hasNotes: true,
  noteCount: 2,
  hasTags: true,
  hasWarnings: false,
  hasErrors: false,
  isImported: true,
  ocrConfidence: 0.85,
  linkedDocuments: ['INV-2023-003'],
  previewUrl: 'https://templates.invoicehome.com/credit-note-template-us-neat-750px.png'
}, {
  id: 'EXP-2023-005',
  type: 'Expense Claim',
  typeCode: 'EXP',
  date: '2023-10-22',
  dueDate: '2023-11-05',
  amount: 387.5,
  status: 'Pending Approval',
  vendor: null,
  entity: 'Global Technologies Inc.',
  site: 'New York HQ',
  createdBy: 'Sarah Williams',
  createdDate: '2023-10-22',
  lastModified: '2023-10-22',
  tags: ['Travel', 'Sales'],
  hasAttachments: true,
  attachmentCount: 3,
  hasNotes: false,
  noteCount: 0,
  hasTags: true,
  hasWarnings: true,
  hasErrors: false,
  isImported: false,
  ocrConfidence: null,
  linkedDocuments: [],
  previewUrl: 'https://templates.invoicehome.com/receipt-template-us-neat-750px.png'
}, {
  id: 'CTR-2023-002',
  type: 'Contract',
  typeCode: 'CTR',
  date: '2023-09-01',
  dueDate: '2024-08-31',
  amount: 24000.0,
  status: 'Active',
  vendor: 'Server Solutions Inc.',
  entity: 'Global Technologies Inc.',
  site: 'New York HQ',
  createdBy: 'Michael Johnson',
  createdDate: '2023-08-25',
  lastModified: '2023-09-01',
  tags: ['IT Department', 'Annual'],
  hasAttachments: true,
  attachmentCount: 4,
  hasNotes: true,
  noteCount: 5,
  hasTags: true,
  hasWarnings: false,
  hasErrors: false,
  isImported: false,
  ocrConfidence: null,
  linkedDocuments: ['PO-2023-010', 'INV-2023-015'],
  previewUrl: null
}, {
  id: 'INV-2023-003',
  type: 'Invoice',
  typeCode: 'INV',
  date: '2023-10-18',
  dueDate: '2023-11-18',
  amount: 4300.0,
  status: 'Exception',
  vendor: 'Dell Technologies',
  entity: 'Global Technologies Inc.',
  site: 'New York HQ',
  createdBy: 'System Import',
  createdDate: '2023-10-18',
  lastModified: '2023-10-19',
  tags: ['IT Department'],
  hasAttachments: true,
  attachmentCount: 1,
  hasNotes: true,
  noteCount: 2,
  hasTags: true,
  hasWarnings: false,
  hasErrors: true,
  isImported: true,
  ocrConfidence: 0.65,
  linkedDocuments: ['CN-2023-001'],
  previewUrl: 'https://templates.invoicehome.com/invoice-template-us-neat-750px.png'
}, {
  id: 'PO-2023-010',
  type: 'Purchase Order',
  typeCode: 'PO',
  date: '2023-09-05',
  dueDate: null,
  amount: 2000.0,
  status: 'Completed',
  vendor: 'Server Solutions Inc.',
  entity: 'Global Technologies Inc.',
  site: 'New York HQ',
  createdBy: 'Michael Johnson',
  createdDate: '2023-09-01',
  lastModified: '2023-09-15',
  tags: ['IT Department'],
  hasAttachments: true,
  attachmentCount: 1,
  hasNotes: false,
  noteCount: 0,
  hasTags: true,
  hasWarnings: false,
  hasErrors: false,
  isImported: false,
  ocrConfidence: null,
  linkedDocuments: ['CTR-2023-002', 'INV-2023-015'],
  previewUrl: 'https://templates.invoicehome.com/purchase-order-template-us-classic-white-750px.png'
}, {
  id: 'INV-2023-015',
  type: 'Invoice',
  typeCode: 'INV',
  date: '2023-09-10',
  dueDate: '2023-10-10',
  amount: 2000.0,
  status: 'Paid',
  vendor: 'Server Solutions Inc.',
  entity: 'Global Technologies Inc.',
  site: 'New York HQ',
  createdBy: 'John Smith',
  createdDate: '2023-09-10',
  lastModified: '2023-09-25',
  tags: ['IT Department'],
  hasAttachments: true,
  attachmentCount: 1,
  hasNotes: false,
  noteCount: 0,
  hasTags: true,
  hasWarnings: false,
  hasErrors: false,
  isImported: true,
  ocrConfidence: 0.95,
  linkedDocuments: ['PO-2023-010', 'CTR-2023-002'],
  previewUrl: 'https://templates.invoicehome.com/invoice-template-us-neat-750px.png'
}, {
  id: 'REQ-2023-008',
  type: 'Requisition',
  typeCode: 'REQ',
  date: '2023-10-25',
  dueDate: null,
  amount: 850.0,
  status: 'Draft',
  vendor: 'PrintWorks Inc.',
  entity: 'Global Technologies Inc.',
  site: 'New York HQ',
  createdBy: 'Sarah Williams',
  createdDate: '2023-10-25',
  lastModified: '2023-10-25',
  tags: ['Marketing'],
  hasAttachments: false,
  attachmentCount: 0,
  hasNotes: true,
  noteCount: 1,
  hasTags: true,
  hasWarnings: true,
  hasErrors: false,
  isImported: false,
  ocrConfidence: null,
  linkedDocuments: [],
  previewUrl: null
}];
export function DocumentLibrary({
  locale = 'en-US'
}) {
  const [documents, setDocuments] = useState(sampleDocuments);
  const [filteredDocuments, setFilteredDocuments] = useState(sampleDocuments);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [bookmarkedDocs, setBookmarkedDocs] = useState([]);
  const [viewMode, setViewMode] = useState('all'); // 'all', 'bookmarked'
  const [isLoading, setIsLoading] = useState(false);
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(true);
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  // Calculate total pages whenever filtered documents change
  useEffect(() => {
    setTotalPages(Math.ceil(filteredDocuments.length / pageSize));
    // Reset to first page when filters change the document set
    setCurrentPage(1);
  }, [filteredDocuments, pageSize]);
  // Get current page documents
  const getCurrentPageDocuments = () => {
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return filteredDocuments.slice(startIndex, endIndex);
  };
  // Apply filters to documents
  const handleFilterChange = filters => {
    setIsLoading(true);
    // Simulate API call delay
    setTimeout(() => {
      let results = [...documents];
      // Apply text search filter
      if (filters.searchText) {
        const searchText = filters.searchText.toLowerCase();
        results = results.filter(doc => doc.id.toLowerCase().includes(searchText) || doc.vendor?.toLowerCase().includes(searchText) || doc.entity.toLowerCase().includes(searchText) || doc.createdBy.toLowerCase().includes(searchText));
      }
      // Apply document type filter
      if (filters.documentTypes && filters.documentTypes.length > 0) {
        results = results.filter(doc => filters.documentTypes.includes(doc.typeCode));
      }
      // Apply status filter
      if (filters.statuses && filters.statuses.length > 0) {
        results = results.filter(doc => filters.statuses.includes(doc.status));
      }
      // Apply date range filter
      if (filters.startDate && filters.endDate) {
        const startDate = new Date(filters.startDate);
        const endDate = new Date(filters.endDate);
        results = results.filter(doc => {
          const docDate = new Date(doc.date);
          return docDate >= startDate && docDate <= endDate;
        });
      }
      // Apply vendor filter
      if (filters.vendor) {
        results = results.filter(doc => doc.vendor === filters.vendor);
      }
      // Apply entity filter
      if (filters.entity) {
        results = results.filter(doc => doc.entity === filters.entity);
      }
      // Apply site filter
      if (filters.site) {
        results = results.filter(doc => doc.site === filters.site);
      }
      // Apply tags filter
      if (filters.tags && filters.tags.length > 0) {
        results = results.filter(doc => doc.tags && doc.tags.some(tag => filters.tags.includes(tag)));
      }
      // Apply amount range filter
      if (filters.minAmount !== undefined && filters.maxAmount !== undefined) {
        results = results.filter(doc => doc.amount >= filters.minAmount && doc.amount <= filters.maxAmount);
      }
      // Apply additional filters
      if (filters.hasAttachments !== undefined) {
        results = results.filter(doc => doc.hasAttachments === filters.hasAttachments);
      }
      if (filters.hasNotes !== undefined) {
        results = results.filter(doc => doc.hasNotes === filters.hasNotes);
      }
      if (filters.hasWarnings !== undefined) {
        results = results.filter(doc => doc.hasWarnings === filters.hasWarnings);
      }
      if (filters.hasErrors !== undefined) {
        results = results.filter(doc => doc.hasErrors === filters.hasErrors);
      }
      if (filters.isImported !== undefined) {
        results = results.filter(doc => doc.isImported === filters.isImported);
      }
      setFilteredDocuments(results);
      setIsLoading(false);
    }, 300);
  };
  // Toggle document bookmark status
  const handleToggleBookmark = docId => {
    if (bookmarkedDocs.includes(docId)) {
      setBookmarkedDocs(bookmarkedDocs.filter(id => id !== docId));
    } else {
      setBookmarkedDocs([...bookmarkedDocs, docId]);
    }
  };
  // Switch between all documents and bookmarked documents
  const handleViewModeChange = mode => {
    setViewMode(mode);
    if (mode === 'bookmarked') {
      setFilteredDocuments(documents.filter(doc => bookmarkedDocs.includes(doc.id)));
    } else {
      setFilteredDocuments(documents);
    }
  };
  // Handle document selection for preview
  const handleDocumentSelect = doc => {
    setSelectedDocument(doc);
    setShowPreview(true);
  };
  // Handle document row click (open in new tab)
  const handleDocumentOpen = doc => {
    console.log('Opening document in new tab:', doc.id);
    // In a real application, this would navigate to the document detail page
    // For now, we'll just log it
  };
  // Handle export selected documents
  const handleExport = format => {
    console.log(`Exporting documents in ${format} format`);
    // In a real application, this would trigger an API call to export the documents
  };
  // Toggle advanced filters visibility
  const toggleAdvancedFilters = () => {
    setShowAdvancedFilters(!showAdvancedFilters);
  };
  // Handle page change
  const handlePageChange = page => {
    setCurrentPage(page);
  };
  // Handle page size change
  const handlePageSizeChange = e => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1); // Reset to first page when changing page size
  };
  return <div className="mb-8" data-id="element-5132">
      <div className="flex justify-between items-center mb-6" data-id="element-5133">
        <div data-id="element-5134">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-5135">Document Library</h2>
          <p className="mt-1 text-sm text-gray-500" data-id="element-5136">
            Search, filter, and view all documents across the system
          </p>
        </div>
        <div className="flex space-x-2" data-id="element-5137">
          <button onClick={() => handleViewModeChange('all')} className={`inline-flex items-center px-3 py-2 border ${viewMode === 'all' ? 'border-indigo-500 bg-indigo-50 text-indigo-700' : 'border-gray-300 text-gray-700 bg-white'} text-sm font-medium rounded-md focus:outline-none`} data-id="element-5138">
            <FileTextIcon className="h-4 w-4 mr-2" data-id="element-5139" />
            All Documents
          </button>
          <button onClick={() => handleViewModeChange('bookmarked')} className={`inline-flex items-center px-3 py-2 border ${viewMode === 'bookmarked' ? 'border-indigo-500 bg-indigo-50 text-indigo-700' : 'border-gray-300 text-gray-700 bg-white'} text-sm font-medium rounded-md focus:outline-none`} data-id="element-5140">
            <BookmarkIcon className="h-4 w-4 mr-2" data-id="element-5141" />
            Bookmarked
          </button>
          <div className="border-l border-gray-300 mx-2" data-id="element-5142"></div>
          <button onClick={() => handleExport('excel')} className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none" data-id="element-5143">
            <DownloadIcon className="h-4 w-4 mr-2" data-id="element-5144" />
            Export
          </button>
          <button onClick={toggleAdvancedFilters} className={`inline-flex items-center px-3 py-2 border ${showAdvancedFilters ? 'border-indigo-500 bg-indigo-50 text-indigo-700' : 'border-gray-300 text-gray-700 bg-white'} text-sm font-medium rounded-md focus:outline-none`} data-id="element-5145">
            <FilterIcon className="h-4 w-4 mr-2" data-id="element-5146" />
            {showAdvancedFilters ? 'Hide Filters' : 'Show Filters'}
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-6" data-id="element-5147">
        {showAdvancedFilters && <DocumentFilters onFilterChange={handleFilterChange} locale={locale} data-id="element-5148" />}
        <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-5149">
          <div className="flex justify-between items-center px-4 py-3 border-b border-gray-200" data-id="element-5150">
            <div className="text-sm text-gray-500" data-id="element-5151">
              Showing{' '}
              <span className="font-medium" data-id="element-5152">
                {Math.min(pageSize, filteredDocuments.length - (currentPage - 1) * pageSize)}
              </span>{' '}
              of <span className="font-medium" data-id="element-5153">{filteredDocuments.length}</span>{' '}
              documents
            </div>
            <div className="flex space-x-2" data-id="element-5154">
              <button onClick={() => handleFilterChange({})} className="inline-flex items-center px-2 py-1 border border-gray-300 text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none" data-id="element-5155">
                <RefreshCwIcon className="h-3 w-3 mr-1" data-id="element-5156" />
                Reset
              </button>
            </div>
          </div>
          <DocumentGrid documents={getCurrentPageDocuments()} bookmarkedDocs={bookmarkedDocs} onToggleBookmark={handleToggleBookmark} onDocumentSelect={handleDocumentSelect} onDocumentOpen={handleDocumentOpen} isLoading={isLoading} locale={locale} data-id="element-5157" />
          {/* Pagination Controls */}
          {filteredDocuments.length > 0 && <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6" data-id="element-5158">
              <div className="flex items-center" data-id="element-5159">
                <span className="mr-2 text-sm text-gray-700" data-id="element-5160">Show</span>
                <select value={pageSize} onChange={handlePageSizeChange} className="mr-2 border-gray-300 rounded-md text-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" data-id="element-5161">
                  <option value="5" data-id="element-5162">5</option>
                  <option value="10" data-id="element-5163">10</option>
                  <option value="25" data-id="element-5164">25</option>
                  <option value="50" data-id="element-5165">50</option>
                </select>
                <span className="text-sm text-gray-700" data-id="element-5166">per page</span>
              </div>
              <div className="flex-1 flex justify-center sm:hidden" data-id="element-5167">
                <button onClick={() => handlePageChange(Math.max(1, currentPage - 1))} disabled={currentPage === 1} className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md ${currentPage === 1 ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-gray-700 hover:bg-gray-50'}`} data-id="element-5168">
                  Previous
                </button>
                <button onClick={() => handlePageChange(Math.min(totalPages, currentPage + 1))} disabled={currentPage === totalPages} className={`ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md ${currentPage === totalPages ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-gray-700 hover:bg-gray-50'}`} data-id="element-5169">
                  Next
                </button>
              </div>
              <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" data-id="element-5170">
                <div data-id="element-5171">
                  <p className="text-sm text-gray-700" data-id="element-5172">
                    Showing{' '}
                    <span className="font-medium" data-id="element-5173">
                      {(currentPage - 1) * pageSize + 1}
                    </span>{' '}
                    to{' '}
                    <span className="font-medium" data-id="element-5174">
                      {Math.min(currentPage * pageSize, filteredDocuments.length)}
                    </span>{' '}
                    of{' '}
                    <span className="font-medium" data-id="element-5175">
                      {filteredDocuments.length}
                    </span>{' '}
                    results
                  </p>
                </div>
                <div data-id="element-5176">
                  <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-5177">
                    <button onClick={() => handlePageChange(1)} disabled={currentPage === 1} className={`relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium ${currentPage === 1 ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500 hover:bg-gray-50'}`} data-id="element-5178">
                      <span className="sr-only" data-id="element-5179">First</span>
                      <span aria-hidden="true" data-id="element-5180">&laquo;&laquo;</span>
                    </button>
                    <button onClick={() => handlePageChange(Math.max(1, currentPage - 1))} disabled={currentPage === 1} className={`relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium ${currentPage === 1 ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500 hover:bg-gray-50'}`} data-id="element-5181">
                      <span className="sr-only" data-id="element-5182">Previous</span>
                      <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-5183" />
                    </button>
                    {/* Page Numbers */}
                    {[...Array(totalPages)].map((_, i) => {
                  const pageNum = i + 1;
                  // Show limited page numbers to avoid cluttering
                  if (pageNum === 1 || pageNum === totalPages || pageNum >= currentPage - 1 && pageNum <= currentPage + 1) {
                    return <button key={pageNum} onClick={() => handlePageChange(pageNum)} className={`relative inline-flex items-center px-4 py-2 border ${currentPage === pageNum ? 'z-10 bg-indigo-50 border-indigo-500 text-indigo-600' : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'} text-sm font-medium`} data-id="element-5184">
                            {pageNum}
                          </button>;
                  }
                  // Add ellipsis for skipped pages
                  if (pageNum === 2 && currentPage > 3 || pageNum === totalPages - 1 && currentPage < totalPages - 2) {
                    return <span key={pageNum} className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700" data-id="element-5185">
                            ...
                          </span>;
                  }
                  return null;
                })}
                    <button onClick={() => handlePageChange(Math.min(totalPages, currentPage + 1))} disabled={currentPage === totalPages} className={`relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium ${currentPage === totalPages ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500 hover:bg-gray-50'}`} data-id="element-5186">
                      <span className="sr-only" data-id="element-5187">Next</span>
                      <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-5188" />
                    </button>
                    <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} className={`relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium ${currentPage === totalPages ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500 hover:bg-gray-50'}`} data-id="element-5189">
                      <span className="sr-only" data-id="element-5190">Last</span>
                      <span aria-hidden="true" data-id="element-5191">&raquo;&raquo;</span>
                    </button>
                  </nav>
                </div>
              </div>
            </div>}
        </div>
      </div>
      {showPreview && selectedDocument && <DocumentPreview document={selectedDocument} onClose={() => setShowPreview(false)} onOpenDocument={() => handleDocumentOpen(selectedDocument)} locale={locale} data-id="element-5192" />}
    </div>;
}